import React from 'react';
import { motion } from 'framer-motion';
export function CTAButton({
  text,
  subtext,
  href = 'https://saludvitalintegral.com/cart/48605167878395:1',
  className = ''
}: {
  text: string;
  subtext?: string;
  href?: string;
  className?: string;
}) {
  const isExternal = !href.startsWith('#');
  return <motion.a href={href} {...isExternal ? {
    target: '_blank',
    rel: 'noopener noreferrer'
  } : {}} className={`inline-flex flex-col items-center justify-center bg-cyan-accent text-dark font-display font-bold text-xl px-8 py-4 uppercase tracking-wide rounded-sm transition-colors text-center ${className}`} whileHover={{
    scale: 1.02,
    backgroundColor: '#ffffff'
  }} whileTap={{
    scale: 0.98
  }} animate={{
    boxShadow: ['0px 0px 10px rgba(0,212,255,0.3)', '0px 0px 25px rgba(0,212,255,0.6)', '0px 0px 10px rgba(0,212,255,0.3)']
  }} transition={{
    duration: 2,
    repeat: Infinity
  }} data-id="element-13">
      <span data-id="element-14">{text}</span>
      {subtext && <span className="text-xs font-sans font-bold normal-case mt-1 opacity-80" data-id="element-15">
          {subtext}
        </span>}
    </motion.a>;
}